import { Styles } from 'react-jss'
import { fieldStatusAppearence } from '../sheet'

export const sheet: Styles = {
  radio: {},
  iconSize: {},
  root: {
    width: 'auto',
    '& > $radio': {
      display: 'none',
      '& + label': {
        position: 'relative',
        cursor: 'pointer',
        width: 'fit-content',
        height: 'fit-content',
        padding: 0,
        '& > $iconSize': {
          width: 16,
          height: 16,
          marginRight: 10,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          flexShrink: 0
        }
      },
      '&:checked, &:not(:checked)': {
        position: 'absolute',
        left: '-9999px'
      },
      '&:checked + label, &:not(:checked) + label': {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        position: 'relative',
        cursor: 'pointer',
        letterSpacing: '0.01em',
        whiteSpace: 'nowrap',
        ...fieldStatusAppearence.text
      }
    }
  }
}
